import { useState } from "react";
import nodeinstance from "../../../../../nodeInstance";
import { useEffect } from "react";

export default function ShowEmployeeDetails({ PopUp, setPopUp, propData }) {
  const headers = [
    "S.NO",
    "MOBILIZATION DATE",
    "DEMOBILIZATION DATE",
    "IDLEAGINING",
  ];

  const token = localStorage.getItem("nodeToken");

  const [data, setData] = useState("");

  const getDaysBetweenDates = (date1, date2) => {
    const firstDate = date1 ? new Date(date1) : new Date();
    const secondDate = date2 ? new Date(date2) : new Date();
    const differenceInMilliseconds = secondDate - firstDate;
    const differenceInDays = Math.floor(differenceInMilliseconds / (1000 * 60 * 60 * 24));
    return differenceInDays;
  };


  // Not in use because getting history data from previous component;
  const getData = async () => {
    try {
      const reqObj = {
        employee_id: propData.employee_id,
        project_id: propData.project_id,
        projectinstance: propData.projectinstance,
      };
      const response = await nodeinstance.post(
        `/mobilization/getEmployeeByInstance`,
        reqObj,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        setData(response.data.data);
      }
    } catch (error) {
      console.log("error to be printed here", error);
    }
  };
  useEffect(() => {
    // getData();
    setData(propData)
  }, [propData]);
  console.log("propData.....propData", propData);
  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${PopUp ? "flex" : "hidden"
          }`}
      >
        <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative">
          <div className="flex justify-between items-center w-full">
            <div className="w-full">
              <div
                className="overflow-x-auto"
                style={{ backgroundColor: "white", width: "100%" }}
              >
                <table className="w-full divide-gray-200">
                  <thead className="bg-gray-100">
                    <tr>
                      {headers.map((columnName, index) => (
                        <th
                          key={index}
                          scope="col"
                          className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider font-semibold"
                        >
                          {columnName}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-gray-10">
                    {data &&
                      data?.history?.map((listItem, index) => {
                        let idleDays = null;

                        if (index === 0) {
                          // First row: mobilization_date - arrival_date 
                          if (data?.arrival_date && listItem.mobilization_date) {
                            idleDays = getDaysBetweenDates(
                              data?.arrival_date,
                              listItem.mobilization_date
                            );
                          }
                        } else {
                          // 2nd row onwards: current_row.mobilization_date -previous_row.demobilization_date
                          const previousRow = data?.history[index - 1];
                          if (previousRow?.demobilization_date && listItem.mobilization_date) {
                            idleDays = getDaysBetweenDates(
                              previousRow.demobilization_date,
                              listItem.mobilization_date
                            );
                          }
                        }
                        return (
                          <tr key={index}>
                            <td className="px-6 py-4 whitespace-nowrap">
                              {index + 1}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                              {listItem.mobilization_date
                                ? new Date(listItem.mobilization_date)
                                  .toLocaleDateString("en-GB", {
                                    day: "2-digit",
                                    month: "short",
                                    year: "numeric",
                                  })
                                  .split(" ")
                                  .join("-")
                                  .toUpperCase()
                                : "-----"}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                              {listItem.demobilization_date
                                ? new Date(listItem.demobilization_date)
                                  .toLocaleDateString("en-GB", {
                                    day: "2-digit",
                                    month: "short",
                                    year: "numeric",
                                  })
                                  .split(" ")
                                  .join("-")
                                  .toUpperCase()
                                : "-----"}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                              {idleDays}
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
              <div className="w-full flex flex-col gap-3 my-3 p-5">
                <div className="flex gap-3 w-full justify-center">
                  <button
                    className="p-3 bg-blue text-white rounded-md w-full max-w-xs m-2 my-4 flex gap-3 justify-center items-center text-sm"
                    onClick={() => {
                      setPopUp(false);
                    }}
                  >
                    <p>Close</p>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
